import dialogMixin from "./dialog";
export default {
  mixins: [dialogMixin],
  data() {
    return {
      isEdit: false
    }
  },
  computed: {
    title() {
      return (this.isEdit ? "修改" : "创建") + " " + this.unit;
    }
  }
}